// Copyright 2025, University of Maryland, All Rights Reserved
import type { KbSchema, KnowledgeBaseItem } from '../types'
import type { KnowledgeBaseSettings } from '../hooks/useKnowledgeBaseSettings'
import type { ItemBrowserResult } from '../hooks/useItemBrowser'
import type { AddItemFormSubmission } from '../items/AddItemForm'
import type { ItemListUpdatePayload } from '../items/ItemList'
import { ItemsTab } from './ItemsTab'

interface KnowledgeBaseTabsProps {
  browser: ItemBrowserResult
  readOnly: boolean
  disableActions: boolean
  items: KnowledgeBaseItem[]
  settings: KnowledgeBaseSettings
  schema?: KbSchema | null
  saving: boolean
  onCreateItem: (submission: AddItemFormSubmission) => Promise<void>
  onUpdateItem: (item: KnowledgeBaseItem, payload: ItemListUpdatePayload) => Promise<void>
  onDeleteItem: (item: KnowledgeBaseItem) => Promise<void>
  onError: (message: string) => void
}

export function KnowledgeBaseTabs({
  browser,
  readOnly,
  disableActions,
  items,
  settings,
  schema,
  saving,
  onCreateItem,
  onUpdateItem,
  onDeleteItem,
  onError,
}: KnowledgeBaseTabsProps): JSX.Element {
  return (
    <ItemsTab
      browser={browser}
      items={items}
      settings={settings}
      schema={schema}
      saving={saving}
      readOnly={readOnly}
      disableActions={disableActions}
      onCreateItem={onCreateItem}
      onUpdateItem={onUpdateItem}
      onDeleteItem={onDeleteItem}
      onError={onError}
    />
  )
}
